// Getters
export const GET_FIRST_CARD = 'GET_FIRST_CARD';

// Mutations
export const MUTATE_FIRST_CARD = 'MUTATE_FIRST_CARD';
